import { API_URL } from '../../../../../actions/utilAction';
import {
  actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    createSearchUrlForCustomAPI,
    extractDataFromObject,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../actions/utilAction';

export {
  jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  extractDataFromObject,
  createSearchUrlForCustomAPI,
  showWarningMessage,
  showErrorMessage,
  showSuccessMessage,
  API_URL,
};

export const GET_ORGANISATION_DATABASE_DETAIL_API = `${API_URL}/OrganizationDatabaseDetail`;

export const manageDatabaseActionTypes = {
  getOrganizationDatabaseDetail: createRequestActionTypes('GET_ORGANISATION_DATABASE_DETAIL'),
  post_database: createRequestActionTypes('POST_DATABASE'),
  delete_database: createRequestActionTypes('DELETE_DATABASE'),
};

export const MODULE = 'SUPERADMIN_MANAGE_DATABASE';



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageDataBase/constants/ApiConstants.js